import { Component, inject } from '@angular/core';
import { InactivityLogoutService } from './services/inactivity-logout.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css'
})
export class App {
  readonly themeService = inject(ThemeService);
  private readonly inactivityLogoutService = inject(InactivityLogoutService);

  constructor() {
    this.inactivityLogoutService.start();
  }
}
